var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7360f2;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Viber"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    className: "cls-1",
    d: "M0,380.2c0-48.65,0-73,15.11-88.09S54.55,277,103.2,277h8.6c48.65,0,73,0,88.09,15.11S215,331.55,215,380.2v8.6c0,48.65,0,73-15.11,88.09S160.45,492,111.8,492h-8.6c-48.65,0-73,0-88.09-15.11S0,437.45,0,388.8Z",
    transform: "translate(0 -277)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Viber-2",
    "data-name": "Viber"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.45,339.36c-3-2.8-15.3-11.7-42.61-11.82,0,0-32.21-1.94-47.91,12.46-8.74,8.74-11.81,21.53-12.14,37.39S49.05,423,77.7,431h0l0,12.3s-.19,5,3.09,6c4,1.23,6.29-2.55,10.08-6.63,2.08-2.24,5-5.53,7.11-8,19.59,1.65,34.66-2.12,36.37-2.68,4-1.28,26.34-4.15,30-33.86C168.1,367.47,162.52,348.09,152.45,339.36Zm3.32,56.54c-3.07,24.81-21.23,26.37-24.58,27.44A101.66,101.66,0,0,1,99.89,426s-12.4,15-16.27,18.85a2.07,2.07,0,0,1-1.79.73c-.67-.16-.85-.95-.85-2.1,0-1.65.11-20.44.11-20.44h0c-24.23-6.73-22.82-32-22.54-45.27s2.76-24.09,10.15-31.39c13.28-12,40.64-10.23,40.64-10.23,23.1.1,34.17,7.06,36.74,9.39,8.52,7.29,12.86,24.76,9.69,50.34Z",
    transform: "translate(0 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Viber-3",
    "data-name": "Viber",
    className: "cls-2",
    d: "M121.08,378.24a1.54,1.54,0,0,1-1.54-1.47c-.26-5.25-2.73-7.81-7.77-8.08a1.54,1.54,0,0,1,.16-3.08c6.66.35,10.36,4.15,10.7,11a1.55,1.55,0,0,1-1.47,1.62Z",
    transform: "translate(0 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Viber-4",
    "data-name": "Viber",
    className: "cls-2",
    d: "M129,380.9h0a1.56,1.56,0,0,1-1.52-1.58,17.81,17.81,0,0,0-4.61-13.07c-3.21-3.51-7.61-5.42-13.45-5.85a1.54,1.54,0,0,1,.22-3.08c6.58.48,11.79,2.78,15.51,6.84a21.1,21.1,0,0,1,5.42,15.23A1.54,1.54,0,0,1,129,380.9Z",
    transform: "translate(0 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Viber-5",
    "data-name": "Viber",
    className: "cls-2",
    d: "M137.12,384.07a1.53,1.53,0,0,1-1.54-1.53c-.07-9.32-2.87-16.74-8.31-22.05a28.67,28.67,0,0,0-20.49-8.1,1.55,1.55,0,1,1,0-3.09h0c9,.07,16.58,3.09,22.62,9s9.17,14.06,9.25,24.23a1.55,1.55,0,0,1-1.54,1.56Z",
    transform: "translate(0 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Viber-6",
    "data-name": "Viber",
    className: "cls-2",
    d: "M112.16,397.38a4.22,4.22,0,0,0,3.34-1.25l2.28-2.87a5,5,0,0,1,6.35-.88c2,1.11,3.84,2.32,5.66,3.61s5.26,4.22,5.27,4.22a4.35,4.35,0,0,1,.92,5.7.43.43,0,0,1,0,0,23.64,23.64,0,0,1-4.74,5.84l0,0a9.36,9.36,0,0,1-4.82,2.33,3.3,3.3,0,0,1-.7,0,6.46,6.46,0,0,1-2-.32l-.05-.07c-2.43-.69-6.49-2.4-13.24-6.13a79,79,0,0,1-11.13-7.35,56.84,56.84,0,0,1-5-4.44l-.17-.17-.17-.17h0l-.17-.16c-.06-.06-.11-.12-.17-.17a58.52,58.52,0,0,1-4.43-5,78.36,78.36,0,0,1-7.35-11.12c-3.73-6.76-5.45-10.81-6.13-13.24l-.08-.06a6.43,6.43,0,0,1-.31-2,3.35,3.35,0,0,1,0-.71,9.58,9.58,0,0,1,2.34-4.82l0,0a23.64,23.64,0,0,1,5.84-4.74h0a4.36,4.36,0,0,1,5.7.91s3,3.54,4.21,5.27a67.17,67.17,0,0,1,3.62,5.67,5,5,0,0,1-.88,6.35l-2.87,2.28A4.21,4.21,0,0,0,92,377.26S96.29,393.33,112.16,397.38Z",
    transform: "translate(0 -277)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViber);
export default __webpack_public_path__ + "static/media/Viber.157dcbfd5018e89a09050ce6dcf3948d.svg";
export { ForwardRef as ReactComponent };